<template>
  <div>
    <div>
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Add New Data</vs-button>
        </div>
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Name</th>
              <th>Parent</th>
              <th>Type</th>
              <th>Url</th>
              <th>Icon</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="data.length > 0">
            <tr v-for='(item, index) in data' :key='index'>
              <td>{{ index+1 }}</td>
              <td :style='item.parent ? "padding-left: 30px" : ""'>{{ item.name }}</td>
              <td>{{ item.parent ? item.parent.name : '-' }}</td>
              <td>
                  <vs-chip v-if='item.type == 0'>Basic</vs-chip>
                  <vs-chip v-else color="success">Premium</vs-chip>
              </td>
              <td>{{ item.url }}</td>
              <td class="text-center">
                <feather-icon v-if='!item.parent' :icon="item.icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
              </td>
              <td style="width: 90px">
                <div class="flex">
                  <vx-tooltip text="Edit" position="top">
                    <vs-button type="border" :id="`editBtn${item.id}`" size="small" icon-pack="feather" icon="icon-edit" color="success" class="mr-2 vs-con-loading__container" @click="edit(item.id)"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="(item.submenu && item.submenu.length === 0) || !item.submenu" text="Delete" position="top">
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" class="mr-2 vs-con-loading__container" @click="del(item.id)"></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td v-if="loading" colspan="7" class="text-center">Loading....</td>
              <td v-else colspan="7" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
      <template>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input label="Name" class="w-full" v-model="input.name" />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Type</label>
            <v-select :options="typeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" v-model="input.type" />
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Parent</label>
            <v-select :options="parentList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" v-model="input.parent" />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="vs-input--label">Position</label>
            <v-select :options="positionList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" v-model="input.position" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input label="URL" class="w-full"  v-model="input.url" />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input label="Icon" class="w-full"  v-model="input.icon" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button :disabled="isSubmit" id="submitBtn" class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
            <vs-button :disabled="isSubmit" v-show="action === 'store'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>
  </div>

</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },

  data () {
    return {
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,
      isSubmit: false,

      oldParent: '',
      position: 0,

      input: {
        id: null,
        name: null,
        parent: null,
        position: null,
        type: {
          value: 0,
          label: 'Basic'
        },
        url: null,
        icon: null
      },
    }
  },

  computed: {
    data() {
      return this.$store.state.Menu.data
    },
    typeList() {
      return this.$store.state.typeList
    },
    parentList() {
      return this.$store.state.Menu.parents
    },
    positionList() {
      return this.$store.state.Menu.positions
    },
    parent() {
      return this.input.parent
    },
  },

  watch: {
    parent(val) {
      if(val) this.getPositionList(val.value)
    },
    positionList(val) {
      this.input.position = val.find(item => {
        return item.value === parseInt(this.position)
      })
    }
  },

  async created () {},
  async mounted () {
    await this.$store.dispatch('Menu/all')
  },

  methods: {
    async getPositionList(parent) {
      const params = this.action == 'store' ? { action: 'add' } : { action: 'edit', parent: this.oldParent, id: this.input.id }
      await this.$store.dispatch('Menu/positions', { parent, params })
    },

    reset() {
      Object.keys(this.input).map(item => {
        if(item === 'type') {
          this.input[item] = this.typeList.find(item => {
            return item.value === 0
          })
        }
        else this.input[item] = null
      })
    },

    async reload() {
      this.loading = true
      await this.$store.dispatch('Menu/all')
      await this.$store.dispatch('Menu/navbar').then(res => {
        const {data} = res.message
        this.$store.dispatch('menu/setMenuItems', data)
      })
      this.loading = false
    },

    async add() {
      if(this.action === 'update') this.reset()
      await this.$store.dispatch('Menu/parents')
      this.action = 'store'
      this.popupTitle = 'Add Menu'
      this.showPopup = true
    },

    async edit(id) {
      this.input.id = id
      await this.$store.dispatch('Menu/parents')
      this.action = 'update'
      this.popupTitle = 'Edit Menu'

      this.loadingStart(`#editBtn${id}`, 'success')
      await this.$store.dispatch('Menu/detail', id).then(data => {
        this.position = data.position
        this.oldParent = data.parent

        this.input = {
          ...data,
          type: this.typeList.find(item => {
            return item.value === data.type
          }),
          parent: this.parentList.find(item => {
            return item.value === data.parent
          }),
        }
      })
      this.loadingStop(`#editBtn${id}`)
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')
      const {status, message} = await this.$store.dispatch(`Menu/${this.action}`, {
        ...this.input,
        type: this.input.type ? this.input.type.value : null,
        parent: this.input.parent ? this.input.parent.value : null,
        position: this.input.position ? this.input.position.value : null,
      })
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if(status) {
        this.showNotify(message)
        this.reload()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Menu`,
        text: 'Are you sure want to Delete this Menu ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const {status, message} = await this.$store.dispatch('Menu/delete', this.input.id)
      if(status) {
        this.showNotify(message)
        this.reload()
      }
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },
    
    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },
    
    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    },
  },
}
</script>
